import React from 'react';

import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import OpenInNew from '@mui/icons-material/OpenInNew';
import CheckIcon from '@mui/icons-material/Check';
import LaunchIcon from '@mui/icons-material/Launch';

const handleClick = (organization, handleActiveOrg, handleOpenEditModal) => {
  handleActiveOrg(organization);
  handleOpenEditModal(true);
};

/* eslint-disable react/prop-types */
const EditButton = ({ organization, handleActiveOrg, handleOpenEditModal }) => (
  <IconButton color='warning' onClick={() => handleClick(organization, handleActiveOrg, handleOpenEditModal)}>
    <EditIcon fontSize='small'/>
  </IconButton>
);

/* eslint-disable react/prop-types */
const RedirectButton = ({ id }) => (
  <IconButton color='warning' onClick={() => window.location.href = '/organizations/' + id }>
    <OpenInNew fontSize='small'/>
  </IconButton>
);

/* eslint-disable react/prop-types */
const StripeButton = ({ stripeAccountId }) => {
  if (!stripeAccountId) return null;
  
  return (
    <IconButton 
      color='primary' 
      onClick={() => window.open(`https://dashboard.stripe.com/connect/accounts/${stripeAccountId}/activity`, '_blank')}
      title={`Stripe Account: ${stripeAccountId}`}
    >
      <LaunchIcon fontSize='small'/>
    </IconButton>
  );
};

/* eslint-disable react/prop-types */
const EuPagoButton = ({ hasEuPago }) => {
  if (!hasEuPago) return null;
  
  return (
    <CheckIcon color='success' fontSize='small'/>
  );
};

export const organizationColumns = (handleActiveOrg, handleOpenEditModal) => [
  {
    name: 'ID',
    selector: (row) => row.id,
    sortable: true,
    width: '75px'
  },
  {
    name: 'Title',
    selector : (row) => row.title,
    sortable: true,
    width: '150px',
    editable: true
  },
  {
    name: 'Status',
    selector : (row) => row.status,
    sortable: true,
    width: '150px',
    editable: true
  },
  {
    name: 'Users',
    selector : (row) => row.students_count,
    sortable: true,
    width: '100px'
  },
  {
    name: 'Net Value',
    selector : (row) => row.net_value,
    sortable: true,
    width: '150px'
  },
  {
    name: 'Service Fees',
    selector : (row) => row.service_fees,
    sortable: true,
    width: '150px'
  },
  {
    name: 'Total Value',
    selector : (row) => row.total_value,
    sortable: true,
    width: '150px'
  },
  {
    name: 'Currency',
    selector : (row) => row.currency,
    sortable: true,
    width: '150px'
  },
  {
    name: 'Stripe',
    selector : (row) => <StripeButton stripeAccountId={row.stripe_charges_enabled ? row.stripe_account_id : null} />,
    sortable: false,
    width: '100px'
  },
  {
    name: 'EuPago',
    // MoR: MB WAY on the Membrz Eupago account; otherwise: the org's own eupago provider
    selector : (row) => <EuPagoButton hasEuPago={row.merchant_of_record ? row.mbway_enabled : row.eupago_charges_enabled} />,
    sortable: false,
    width: '100px'
  },
  {
    name: 'MoR',
    selector : (row) => row.merchant_of_record ? <CheckIcon color='success' fontSize='small'/> : null,
    sortable: true,
    width: '100px'
  },
  {
    selector : (row) => <RedirectButton id={row.id} />,
    sortable: false,
    width: '75px'
  },
  {
    selector : (row) => <EditButton organization={row} handleActiveOrg={handleActiveOrg} handleOpenEditModal={handleOpenEditModal} />,
    sortable: false,
    width: '75px'
  },
];
